const map = {
	"./EHK_Betondachsteine.png": 4846,
	"./EHK_Biberschwanzziegel.png": 966,
	"./EHK_SINFONIE.png": 631,
	"./EHK_Tondachziegel.png": 1631,
	"./ESK_ANTICO.png": 5551,
	"./ESK_AUREUS.png": 6284,
	"./ESK_Betondachsteine.png": 587,
	"./ESK_ETRUSKO.png": 2808,
	"./ESK_KAPSTADT.png": 5315,
	"./ESK_PROFIL_Strangfalzziegel.png": 6258,
	"./ESK_ROMANO.png": 7631,
	"./ESK_Tondachziegel.png": 7442,
	"./SCHRAUBE_Edelstahl.png": 1433
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4464;